import getScaleFromRes from '../utils/getScaleFromRes.js';
import Style from 'ol/style/Style.js';
import {calculateArrowPointOnLineString} from '../Style/calculateArrowPointOnLineString.js';
import {calculateArrowPointOnMultiLineString} from '../Style/calculateArrowPointOnMultiLineString.js';

export function buildArrowSymbolizer(lineSymbolizer, options, map) {
    var renderResolution = options['maprender'];
    var arrowSymbolizer = {
        kind: 'StyleFunction',
        visible: true,
        style: function (feature, o) {

            var renderScale = renderResolution
                ? renderResolution
                : feature.get('renderScaleGrodan');
            var zuruu;

            if (renderScale != null) {
                if (map != undefined) {
                    o = getScaleFromRes(map)
                }
                zuruu = parseFloat(renderScale) / o;
            } else {
                if (map != undefined) {
                    o = getScaleFromRes(map)
                }
            }

            const geometry = feature.getGeometry();

            if (geometry.getType() != 'LineString' && geometry.getType() != 'MultiLineString') {

                return new Style();

            }

            var arrowObj = JSON.parse(lineSymbolizer['arrow'])
            var arrowColor = arrowObj['color'];
            var arrowStrokeWidth = arrowObj['width'];
            var foreachSegment = arrowObj['foreachSegment'];
            var toRight = arrowObj['toRight'];
            var placement = arrowObj['placement'];

            var Arrowsvg = decodeURIComponent(arrowObj['svg']);

            var stylesArr = null;
            if (!stylesArr) {

                function calculateArrowPoints(
                    allcooirdinates,
                    placement,
                    foreachSegment,
                    toRight,
                    multiLineString
                ) {
                    var points = [];
                    var angles = [];

                    if (multiLineString) {
                        var result = calculateArrowPointOnMultiLineString(
                            allcooirdinates,
                            points,
                            angles,
                            placement,
                            foreachSegment,
                            toRight
                        );
                        points = result.points;
                        angles = result.angles;
                    } else {
                        var result = calculateArrowPointOnLineString(
                            allcooirdinates,
                            points,
                            angles,
                            placement,
                            foreachSegment,
                            toRight
                        );
                        points = result.points;
                        angles = result.angles;
                    }

                    var newGeom = new ol
                        .geom
                        .MultiPoint(points);
                    newGeom.set('angle', angles);

                    return newGeom;
                }

                var svgMarkup = Arrowsvg
                    .replaceAll('{{color}}', arrowColor)
                    .replaceAll('{{width}}', arrowStrokeWidth);

                var anchor = [0.85, 0.5];
                if (placement == 'start') {
                    anchor = [0.15, 0.5];
                } else if (placement == 'mid') {
                    anchor = [0.5, 0.5];
                }

                stylesArr = [
                    new ol
                        .style
                        .Style({
                            geometry: function (feature) {
                                if (feature.getGeometry().getType() == 'LineString') {

                                    const coordinates = feature
                                        .getGeometry()
                                        .getCoordinates();

                                    return calculateArrowPoints(coordinates, placement, foreachSegment, toRight);

                                } else if (feature.getGeometry().getType() == 'MultiLineString') {

                                    const coordinates = feature
                                        .getGeometry()
                                        .getCoordinates();

                                    return calculateArrowPoints(
                                        coordinates,
                                        placement,
                                        foreachSegment,
                                        toRight,
                                        true
                                    );

                                }

                            },
                            image: new ol
                                .style
                                .Icon({
                                    anchor: anchor,
                                    rotateWithView: true,
                                    src: 'data:image/svg+xml;utf8,' + encodeURIComponent(svgMarkup),
                                    scale: zuruu
                                        ? 1 * zuruu
                                        : 1
                                            ? 1
                                            : 1,
                                })
                        })
                ];
            }

            return stylesArr[0];
        }
    };
    return arrowSymbolizer;
}
